<head>
  <script src="https://code.highcharts.com/highcharts.js"></script>
  <script src="https://code.highcharts.com/modules/exporting.js"></script>
  <script src="https://code.highcharts.com/modules/offline-exporting.js"></script>
  <script src="https://code.highcharts.com/modules/export-data.js"></script>
</head>
@if (clientBrandingService.isLoaded()) {
  <rdo-maintenance-window>
    @if (this.authenticationService._userInfoView.SelectedClient) {
      <rdo-header></rdo-header>
    }
    <rdo-filter [hidden]="!this.authenticationService._userInfoView.SelectedClient"></rdo-filter>
    <rdo-navigation [hidden]="!this.authenticationService._userInfoView.SelectedClient || !this.filterInfoService.isLoaded()"></rdo-navigation>
    <rdo-guided-tours-management [hidden]="!this.authenticationService._userInfoView.SelectedClient"></rdo-guided-tours-management>
    <main [ngClass]="mainClass" [rdoToasts]>
      <router-outlet></router-outlet>
    </main>
    <!-- <main [hidden]="!this.authenticationService._userInfoView.SelectedClient">
    <router-outlet></router-outlet>
    <hotkeys-cheatsheet title="{{'main.core.rental_dashboard_keyboard_shortcuts' | translate}}:"></hotkeys-cheatsheet>
  </main> -->
  <rdo-cookie-consent></rdo-cookie-consent>
</rdo-maintenance-window>
}
